export default __webpack_public_path__ + "static/media/Ballroll_00089.61a7e300.png";